/**
 * useInAppReview — déclenche le dialog Google Play In-App Review
 * après 5 sessions authentifiées, puis toutes les 30 jours.
 *
 * L'API Google ne garantit pas l'affichage (quota ~1/4 semaines).
 * On ne sait jamais si l'utilisateur a noté ou fermé — c'est voulu.
 */

import { useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { InAppReview } from '@capacitor-community/in-app-review';
import { useAuthStore } from '@/stores';

const SESSION_KEY = 'mycopro_session_count';
const LAST_REVIEW_KEY = 'mycopro_last_review';
const MIN_SESSIONS = 5;
const MIN_DAYS = 30;

export const useInAppReview = () => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const triggered = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || triggered.current) return;
    if (!Capacitor.isNativePlatform()) return;

    triggered.current = true;

    const count = parseInt(localStorage.getItem(SESSION_KEY) || '0') + 1;
    localStorage.setItem(SESSION_KEY, String(count));

    if (count < MIN_SESSIONS) return;

    const lastReview = parseInt(localStorage.getItem(LAST_REVIEW_KEY) || '0');
    const daysSinceLast = (Date.now() - lastReview) / (1000 * 60 * 60 * 24);

    if (lastReview === 0 || daysSinceLast >= MIN_DAYS) {
      setTimeout(async () => {
        try {
          await InAppReview.requestReview();
          localStorage.setItem(LAST_REVIEW_KEY, String(Date.now()));
        } catch {
          // Non-critique — le dialog n'apparaît pas si le quota Google est atteint
        }
      }, 3000);
    }
  }, [isAuthenticated]);
};
